import { CLEANUP_STALE_ENTITIES, CleanupStaleEntitiesAction } from "./types";

export const cleanupStaleEntitiesAction = (): CleanupStaleEntitiesAction => {
  return {
    type: CLEANUP_STALE_ENTITIES,
  };
};
